import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// COMPONENTS
import Button from '../../components/Button';

// ICONS
import { ReactComponent as MailIcon } from '../../assets/svg/mail-sent.svg';
import { ReactComponent as TickIcon } from '../../assets/svg/tick-circle.svg';

// TYPES
import { UserInfoType } from './CreateAccount';

interface CheckEmailTypes {
	userInfo: UserInfoType;
}

export const CheckEmail: React.FC<CheckEmailTypes> = ({ userInfo }) => {
	const [loading, setLoading] = React.useState<boolean>(false);
	const [emailSent, setEmailSent] = React.useState<boolean>(false);
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const resendEmail = async () => {
		setEmailSent(false);

		setLoading(true);

		const fieldValues = { ...userInfo };

		const response = await apibridge.doResendEmailVerification(fieldValues);

		setLoading(false);

		if (response.isError) {
			setFormErrorMessage(
				response.validationErrors.length ? validationErrorsToString(response.validationErrors) : response.message
			);
		} else if (response.result) {
			setEmailSent(true);
		}
	};

	return (
		<div className="check-email">
			<div className="header">
				<MailIcon className="icon" />

				<h1 className="h1">You’re almost done...</h1>
			</div>

			{!userInfo.parentEmail ? (
				<>
					<div className="content">
						<p>
							A confirmation email has been sent to <em>{userInfo.email}</em>
						</p>

						<p>Please follow the link in the email to activate and&nbsp;confirm&nbsp;your&nbsp;account.</p>

						<p>
							If you don’t receive an email, it may be because you already have a ChildAware account associated with
							this email address. Please log in with your existing account.
						</p>
					</div>

					<div className="actions">
						{!!formErrorMessage && <div className="form-validation-error">{formErrorMessage}</div>}

						{!!emailSent && (
							<div className="form-validation-success">
								<TickIcon className="icon" />
								Email sent
							</div>
						)}

						<Button className="btn-primary" onClick={resendEmail} disabled={loading}>
							Resend Email
						</Button>
					</div>
				</>
			) : (
				<div className="content">
					<p className="mbtom-8">
						A verification email has been sent to your parent’s email address: <em>{userInfo.parentEmail}</em>
					</p>

					<p>Your parent must verify your account before you can start using ChildAware.</p>
				</div>
			)}
		</div>
	);
};

export default CheckEmail;
